import { render, staticRenderFns } from "./ReceiptEdit.vue?vue&type=template&id=0a8f4f07&scoped=true&"
import script from "./ReceiptEdit.vue?vue&type=script&lang=js&"
export * from "./ReceiptEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptEdit.vue?vue&type=style&index=0&id=0a8f4f07&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f4f07",
  null
  
)

export default component.exports